<template>
  <tv-page title="TV标销-我的订单" :class="_.page">
    <template v-if="!loading">
      <div :class="_.my_order">
        <p ref="returnTop" v-focusable :class="_.title">我的订单</p>
        <p :class="_.hint">
          多彩宝账号（{{ userInfo.phoneNo }}）TV端订单数据已同步到多彩宝APP
        </p>
        <van-list
          v-if="showList"
          v-model="loadinglist"
          :finished="finished"
          :finished-text="!list.length ? '' : '已经到底了～'"
          @load="onLoad"
        >
          <ul ref="list">
            <li
              v-for="(item, index) in list"
              :key="index"
              v-focusable
              v-on="orderListeners"
            >
              <p :class="_.status">
                <span>{{ item.merchantName }}</span>
                <span v-if="item.status === 0">待支付</span>
                <span v-if="item.status === 300">待使用</span>
                <span v-if="item.status === 902">交易完结</span>
              </p>
              <div :class="_.content">
                <img :src="item.commodityPic" :class="_.cover" />
                <div>
                  <p :class="_.number">
                    <span>{{ item.commodityName }}</span>
                    <span>x{{ item.quantity }}</span>
                  </p>
                  <p v-if="item.expireTime" :class="_.date">
                    有效期至：{{ item.expireTime }}
                  </p>
                  <p :class="_.price">￥{{ item.payAmount }}</p>
                </div>
              </div>
            </li>
          </ul>
          <tv-empty v-if="!list.length && !loadinglist" message="暂无订单" />
        </van-list>
      </div>
    </template>
  </tv-page>
</template>

<script>
  import Vue from 'vue'
  import { apiOrderOrderGetUserInfo, apiOrderWriteOffOrderList } from '@/api'
  import { defineTvListeners } from '../../utils'
  import { navigateTo } from '../../../../router'
  import { Track } from '@/utils'

  export default Vue.extend({
    mixins: [
      Track.provideMark(() => ({
        // 埋点页面名称
        name: 'TV标销-我的订单',
      })),
    ],
    data() {
      return {
        // 页面加载状态
        loading: true,
        list: [],
        loadinglist: false,
        showList: true,
        finished: false,
        pageNo: 1,
        pageSize: 10,
        userInfo: '', //用户信息
        //跳到订单列表
        goToList: index => {
          this.$tv.goTo(this.$refs.list, index)
        },
        //我的订单列表监听
        orderListeners: defineTvListeners(
          ({ type, index, isFirst, isLast }) => {
            switch (type) {
              case 'left':
                if (isFirst) {
                  this.goToList(index)
                } else {
                  this.goToList(index - 1)
                }
                break
              case 'right':
                if (!isLast) {
                  this.goToList(index + 1)
                } else {
                  this.goToList(index)
                }
                break
              case 'click':
                this.handleClickOrder(this.list[index].orderNo)
                break
              default:
                break
            }
          },
        ),
      }
    },

    async activated() {
      this.showList = false
      this.list = []
      this.pageNo = 1
      this.loadinglist = false
      this.finished = false
      this.$nextTick(() => {
        this.showList = true
      })
    },

    async mounted() {
      await this.getUserInfo()
      this.loading = false
    },

    methods: {
      onLoad() {
        this.getList()
        this.goToList(0)
      },
      getList() {
        apiOrderWriteOffOrderList({
          status: 4,
          pageIndex: this.pageNo,
          pageSize: this.pageSize,
        }).then(res => {
          this.list = [...this.list, ...res.list]
          this.loadinglist = false
          if (!res.list.length) {
            this.finished = true
          } else {
            this.pageNo++
          }
        })
      },

      getUserInfo() {
        return apiOrderOrderGetUserInfo().then(res => {
          this.userInfo = res
        })
      },

      handleClickOrder(orderNo) {
        navigateTo('TvBookOrderDetail', { orderNo: orderNo })
      },
    },
  })
</script>

<style lang="scss" module>
  .page {
    background-color: #1f2733;
  }
  .my_order {
    padding: 40px 80px;
    height: 100%;
    overflow-y: scroll;

    .hint {
      font-size: 32px;
      color: #787d84;
      line-height: 32px;
      text-align: center;
      margin-bottom: 40px;
    }

    .title {
      font-size: 48px;
      color: #ffffff;
      line-height: 70px;
      margin-bottom: 14px;
      text-align: center;

      &[focused] {
        &::after {
          display: none;
        }
      }
    }

    ul {
      display: grid;
      grid-template-columns: 860px 860px;
      grid-gap: 40px;

      li {
        background: #ffffff;
        border-radius: 12px;
        --border-radius: 12px;

        .status {
          display: flex;
          justify-content: space-between;
          font-size: 32px;
          color: #333333;
          line-height: 46px;
          padding: 20px;
          border-bottom: 1px solid #cccccc;

          span:last-child {
            color: #ff3b30;
          }

          span:first-child {
            width: 670px;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }

        .content {
          padding: 20px;
          display: flex;

          .cover {
            width: 230px;
            height: 230px;
            object-fit: cover;
            border-radius: 8px;
            margin-right: 20px;
            overflow: hidden;
          }

          .number {
            display: flex;
            justify-content: space-between;
            font-size: 36px;
            color: #333333;
            line-height: 52px;
            width: 570px;
            margin-bottom: 20px;

            span:first-child {
              font-weight: bold;
            }
          }

          .date {
            font-size: 30px;
            color: #999999;
            line-height: 44px;
            margin-bottom: 54px;
          }

          .price {
            font-size: 50px;
            font-weight: bold;
            color: #ff3b30;
            line-height: 60px;
          }
        }
      }
    }
  }
</style>
